import { createSvgIcon } from "@mui/material";
import { extractHexColor } from "styles/hexOpacity";
import { theme } from "styles/theme";

export default function HighlightIndicator() {
  const color = extractHexColor(theme.vars.palette.primary.solid);
  const LogoIcon = createSvgIcon(
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 18C24 24.6274 18.6274 30 12 30C5.37258 30 0 24.6274 0 18C0 12.7505 7.52892 4.52378 10.6596 1.32991C11.4036 0.570869 12.5964 0.570869 13.3404 1.32991C16.4711 4.52378 24 12.7505 24 18Z"
        fill={color}
      />
    </svg>,
    "HighlightIcon"
  );

  return <LogoIcon />;
}

export function HighlightIndicatorWithNumber({
  number,
}: {
  number: number | string;
}) {
  return (
    <svg
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2769_6375)">
        <path
          d="M23.3473 10.6821C23.7078 10.3216 24.2922 10.3216 24.6527 10.6821L32.4853 18.5147C37.1716 23.201 37.1716 30.799 32.4853 35.4853C27.799 40.1716 20.201 40.1716 15.5147 35.4853C10.8284 30.799 10.8284 23.201 15.5147 18.5147L23.3473 10.6821Z"
          fill="#0F55A7"
        />
        <g clipPath="url(#clip0_2769_6375)">
          <path
            d="M14 27C14 21.4772 18.4772 17 24 17C29.5228 17 34 21.4772 34 27C34 32.5228 29.5228 37 24 37C18.4772 37 14 32.5228 14 27Z"
            fill="white"
          />
          <foreignObject x="14" y="17" width="20" height="20">
            <div style={{ display: 'flex', width: '20px', height: '20px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexShrink: 0, fontSize: '12px', fontWeight: 700, color: '#0F55A7', lineHeight: 1 }}>
              {number}
            </div>
          </foreignObject>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2769_6375"
          x="0"
          y="0.411743"
          width="48"
          height="52.5883"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2769_6375"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2769_6375"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2769_6375">
          <path
            d="M14 27C14 21.4772 18.4772 17 24 17C29.5228 17 34 21.4772 34 27C34 32.5228 29.5228 37 24 37C18.4772 37 14 32.5228 14 27Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HighlightIndicatorWithQ() {
  return (
    <svg
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2769_6375)">
        <path
          d="M23.3473 10.6821C23.7078 10.3216 24.2922 10.3216 24.6527 10.6821L32.4853 18.5147C37.1716 23.201 37.1716 30.799 32.4853 35.4853C27.799 40.1716 20.201 40.1716 15.5147 35.4853C10.8284 30.799 10.8284 23.201 15.5147 18.5147L23.3473 10.6821Z"
          fill="#0F55A7"
        />
        <g clipPath="url(#clip0_2769_6375)">
          <path
            d="M14 27C14 21.4772 18.4772 17 24 17C29.5228 17 34 21.4772 34 27C34 32.5228 29.5228 37 24 37C18.4772 37 14 32.5228 14 27Z"
            fill="white"
          />
          <foreignObject x="14" y="17" width="20" height="20">
            <div style={{ display: 'flex', width: '20px', height: '20px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexShrink: 0, fontSize: '12px', fontWeight: 700, color: '#0F55A7', lineHeight: 1 }}>
              Q
            </div>
          </foreignObject>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2769_6375"
          x="0"
          y="0.411743"
          width="48"
          height="52.5883"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2769_6375"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2769_6375"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2769_6375">
          <path
            d="M14 27C14 21.4772 18.4772 17 24 17C29.5228 17 34 21.4772 34 27C34 32.5228 29.5228 37 24 37C18.4772 37 14 32.5228 14 27Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CompletedHighlightIndicator() {
  return (
    <svg
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2769_6362)">
        <path d="M23.3473 10.6821C23.7078 10.3216 24.2922 10.3216 24.6527 10.6821L32.4853 18.5147C37.1716 23.201 37.1716 30.799 32.4853 35.4853C27.799 40.1716 20.201 40.1716 15.5147 35.4853C10.8284 30.799 10.8284 23.201 15.5147 18.5147L23.3473 10.6821Z" fill="#0F55A7"/>
        <path d="M19 26.0384L22.5294 31.1666L29 22.8333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_d_2769_6362" x="0" y="0.411743" width="48" height="52.5883" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="6"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2769_6362"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2769_6362" result="shape"/>
        </filter>
      </defs>
    </svg>
  );
}
